var React = require('react');

function ContentMembership (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m82,0H10C4.48,0,0,4.48,0,10v46.34c0,5.52,4.48,10,10,10h72c5.52,0,10-4.48,10-10V10c0-5.52-4.48-10-10-10Zm6,56.33c0,3.31-2.69,6-6,6H10c-3.31,0-6-2.69-6-6V10c0-3.31,2.69-6,6-6h72c3.31,0,6,2.69,6,6v46.33Z","key":0}),React.createElement("path",{"d":"m45,27.71l-9.66-1.4-4.34-8.75c-.49-.99-1.69-1.4-2.68-.91-.4.2-.72.52-.91.91l-4.32,8.75-9.66,1.4c-1.1.12-1.89,1.11-1.76,2.21.05.48.28.92.63,1.25l7,6.81-1.65,9.62c-.19,1.09.54,2.12,1.63,2.31.43.07.88,0,1.27-.2l8.63-4.54,8.64,4.54c.98.51,2.19.14,2.7-.84.2-.39.27-.83.2-1.27l-1.65-9.62,7-6.81c.82-.74.88-2.01.13-2.83-.31-.35-.74-.57-1.2-.63Z","key":1})]);
}

ContentMembership.defaultProps = {"role":"presentation","id":"uuid-f37e86b0-9150-4c0e-9771-09e577b1b74e","data-name":"Layer 1","viewBox":"0 0 92 66.34"};

module.exports = ContentMembership;

ContentMembership.default = ContentMembership;
